export enum AuthMode {
    login = 'login',
    verify = 'verify',
    reset = 'reset'
  }
  
  export enum AuthMethod {
    email = 'email',
    sms = 'sms'
  }
